import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { SmartFormInterFace, SmartSoftForm } from "soft_digi";
import { SmartValid, ValidateFormNew } from "soft_digi/dist/services/smartValidationService";
import { TASK_API_URLS } from "../../api/TaskApiUrls";
import { useSiteContext } from "../../contexts/SiteProvider";
import { LOADING } from "../../services/MsgService";
import { showNotification } from "../../services/notifyService";
import { post } from "../../services/smartApiService";
const DscRegister = () => {
  const [formData, setFormData] = useState<any>({});
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const { setLoading } = useSiteContext();
  const navigate = useNavigate()



  const loadData = () => {
    // return setFormData(sampleData)
    setLoading(true, "Loading.. Please Wait");
    const subscription = post(TASK_API_URLS.GET_ONE, { id: token },{loadingMsg:LOADING.DSC_REGISTER}).subscribe((response) => {
      setFormData(response.data.data)
      setLoading(false);
    });
    return () => {
      subscription.unsubscribe();
    };
  };

  useEffect(() => {
    if (token)
      loadData()
  }, [token])

  const handleSave = () => { 
    if (!ValidateFormNew(formData,formElements)) return false;
    if(formData?.cert_pfx == "") return showNotification("error","Please upload Certificate (pfx)");  
    const payload = {
      task_id: token,
      cert_pfx: formData?.cert_pfx?.content,
      cert_pem:"",
      cert_pin: formData?.cert_pin,
      cert_type: formData?.dsc_type || "SOFTKEY"
    }
    const api = TASK_API_URLS.REGISTER_DSC_TASK;
    const subscription = post(api,payload).subscribe((response) => {     
      navigate("/auth/dsc");
    });
    return () => subscription.unsubscribe();
  };

  const validations = {
    cert_pin: [ SmartValid.required("Required")],
  };

  const formElements:SmartFormInterFace.SmartFormElementProps[] = [
    {
      type: "TEXT_BOX",
      width: "7",
      name: "task_user_id",
      element: {
        isHorizontal: true,
        label: <div className="mr-5 mt-2">Employee Id</div>,
        classList:[""],
        placeHolder: "Enter your Employee Id",
        leftIcon:"fa-user",
        inputProps:{ 
          disabledFunction:()=>{
            return true
          } 
        }
      },
    },
    {
      type: "TEXT_BOX",
      width: "7",
      name: "dsc_type",
      element: {
        isHorizontal: true,
        classList:[""],
        label: <div className="mr-5 mt-2">DSC Type</div>,
        placeHolder: "Select DSC Type",
        inputProps:{ 
          disabledFunction:()=>{
            return true
          } 
        }
      }
    },
    {
      type: "TEXT_BOX",
      width: "7",
      name: "task_user_name",
      element: {
        isHorizontal: true,
        classList:[""],
        label: <div className="mr-5 mt-2">Employee Name</div>,
        placeHolder: "Enter your Name",
        inputType:"NORMAL",
        leftIcon:"fa-user",
        inputProps:{ 
          disabledFunction:()=>{
            return true
          } 
        } 
      },
    },
    {
      type: "FILE",
      width: "7",
      name: "cert_pfx",
      element: {
        isHorizontal: true,
        label: <div className="mr-5 mt-2">Certificate</div>,
        classList:[""],
        placeHolder: "Browse Certificate",
        accept: "pdf",
        inputProps:{ 
          disabledFunction:()=>{
            return true
          } 
        }
      },
    },
    {
      type: "TEXT_BOX",
      width: "7",
      name: "cert_pin",
      element: {
        isHorizontal: true,      
        label: <div className="mr-5 mt-2">Certificate PIN</div>,
        placeHolder: "Enter PIN",
        inputType:"NORMAL",
        leftIcon:"fa-user",
        validations: validations.cert_pin,
      },
    },
    {
      type: "BUTTON",
      width: "12",
      name:"",
      class_name: "has-text-right",
      element: {
        label: "Register DSC",
        classList: ["smart-action-button"],
        onClick: handleSave,
      },
    },
];

  const handleInputChange = (name: string, value: string) => {
    setFormData((prev:any) => ({ ...prev, [name]: value }));
  };

  console.log(formData);
  

  return (
    <>
    <div className="title mb-6 is-4">DSC Registation form</div>
    <div className="sd-pdf-form sd-pdf-horizontal-form">  
      <SmartSoftForm
        formData={formData}
        setFormData={handleInputChange}
        elements={formElements}
        />
    </div>
    </>
  )
}

export default DscRegister